var scope_0 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2b738e3e48b319fa821a4d9693215fad.js').default;
var scope_1 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2fa02ff664bd810e876fd0254af99a91.js').default;
var scope_2 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3af2086e8205c052467e8fc66622f2fa.js').default;
var scope_3 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4e5c54ea560ccd4f382f1870609ccb37.js').default;
var scope_4 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5e3de85b02ebfe64b3a6ab3b4a53ad9f.js').default;
var scope_5 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/728fbc7502d8b78d1ebe1a4b3e09cef8.js').default;
var scope_6 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8228f0550d10716c355c5419899c4999.js').default;
var scope_7 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/82870bdc222422689a47c2020f29618e.js').default;
var scope_8 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/84056598bf58e0d25281ad5b097b7e3b.js').default;
var scope_9 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8fa3469e8c7caefa92d2aad67f1164e7.js').default;
var scope_10 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99d2f8b3f04970c691663cdfe4bb63ae.js').default;
var scope_11 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ea76785e7e173d65f77575dc5382f79.js').default;
var scope_12 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a5f7fcd94379d81017a3213a3aed1e55.js').default;
var scope_13 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a948709afb5d88a3ff821fa46e7a6bc0.js').default;
var scope_14 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/be45759647e4f021436c7bd0a0fb7aa5.js').default;
var scope_15 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c5afb6277bc02c97fb706440f727d6b7.js').default;
var scope_16 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d0716fd16c721f8d88c444bacd812c0e.js').default;
var scope_17 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dd07f637ac57f9ec7e08d329324693d7.js').default;
var scope_18 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_19 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f60be70a4861e0bb7e37cd81d8c0f1f9.js').default;
var scope_20 = require('/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f8ef75526edcef8409b9f30f86145f47.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20 )
    